// import { utilities } fro./available-utility-providersock';
import { plans } from './available-utility-plans';
import { enrollmentInfo } from './plan-enrollment-info-mock';
import { depositRequiredResponse } from './enroll-utility-subscription-deposit-required';
import { availableUtilityProvidersMock } from './available-utility-providers';
// import { availableUtilityProvidersMock } from './available-utility-providers-with-subscription';

const createClient = () => {
  const availableUtilityProviders = () => {
    return Promise.resolve(
      availableUtilityProvidersMock.data.availableUtilityProviders
    );
  };

  const availableUtilityPlans = () => {
    return Promise.resolve(plans);
  };

  const utilityPlanEnrollmentInfo = () => {
    return Promise.resolve(enrollmentInfo);
  };

  const enrollUtilitySubscription = () => {
    return Promise.resolve(depositRequiredResponse);
  };

  return {
    availableUtilityProviders,
    availableUtilityPlans,
    utilityPlanEnrollmentInfo,
    enrollUtilitySubscription,
  };
};

export default createClient;
